export const dashboardMessages = {
  dashboardError: 'Something went wrong. If the issue persists,'
  + ' please contact your MikMak representative.',
  permalinkSaveError: 'There was an issue generating a permalink for your report.'
  + ' If the issue persists, please contact your MikMak representative.',
  permalinkRetrievalError: 'Cannot load report. Please refresh your page.',
  csvDownloadError: 'There was an issue downloading your report,'
  + ' please try again.',
  responseSizeTooLargeError: 'The dataset you requested is too large. Please refine your query.',
  forceClearFilters: 'Your filters have been cleared as a result of a change in your brand selection.',
  explorerRowsAreEmpty: 'No insights available for the selected metrics, dimensions and filters.',
  default: 'Something went wrong. If the issue persists,'
  + ' please contact your MikMak representative.',
  liveRampOff: 'Due to inactivity in use of Shopper Intelligence, processing of data from LiveRamp'
    + ' has been turned off. Please get in touch with your MikMak Customer Success Manager for'
    + ' more information.',
  interactionTimeNewMetric: 'We’ve just launched a new metric, Average Interaction Time, measuring shopper interaction time. Check it out in Explorer!',
  avgTimeSpentDeprecation: 'The Average Time Spent Metric will no longer be available after May 15th.',
};
